import { render, staticRenderFns } from "./ModalDetailItem.vue?vue&type=template&id=45bf39ae&"
import script from "./ModalDetailItem.vue?vue&type=script&lang=js&"
export * from "./ModalDetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports